<ng-template #modal>
    <div id="shared-modal-injection-container"></div>
</ng-template>